// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"c2976b63","397":"453a96ab","473":"990eb3df","495":"0e4787f1"}[chunkId] + ".chunk.js";
};